export default function initSleekBar(isSleekBarOpened) {

    const trigger = "[data-sleek-menu]",
        sleekOpenNav = "menu--sleek-open",
        openSleekBarContainerClass = "sleek-bar-container--open",
        visibleSleekBarMenuContainerClass = "sleek-bar__menu__container--visible",
        activeMenuListItemClass = "menu__list__item__link--active",
        $nav = $(".menu"),
        $mainContainer = $(".main-container"),
        $sleekBarContainer = $(".sleek-bar-container"),
        $sleekBarMenuContainer = $(".sleek-bar__menu__container"),
        $document = $(document);

    function toggleLink($clickedLink) {

        const $activeLink = $("." + activeMenuListItemClass);
        const activeLinkId = $activeLink.attr("id");
        $activeLink.removeClass(activeMenuListItemClass);

        if (activeLinkId !== $clickedLink.attr("id")) {
            $clickedLink.addClass(activeMenuListItemClass);
            $sleekBarContainer.addClass(openSleekBarContainerClass);
            $nav.addClass(sleekOpenNav);
            isSleekBarOpened = true;

        } else {
            $nav.removeClass(sleekOpenNav);
            $sleekBarContainer.removeClass(openSleekBarContainerClass);
            isSleekBarOpened = false;
        }
    }

    function toggleMenu($clickedLink) {
        const clickedId = $clickedLink.attr("data-sleek-menu");
        const $clicked = $("#" + clickedId);
        $sleekBarMenuContainer.removeClass(visibleSleekBarMenuContainerClass);
        $clicked.addClass(visibleSleekBarMenuContainerClass);
    }

    function closeSleekBar() {
        $(trigger).removeClass(activeMenuListItemClass);
        $nav.removeClass(sleekOpenNav);
        $sleekBarContainer.removeClass(openSleekBarContainerClass);
        isSleekBarOpened = false;
    }

    // Listen for a click outside the sleek bar in order to close it
    function mouseDownOutsideSleekBarListener(e) {

        // if the click event occurred outside the navbar
        if (!$sleekBarContainer.is(e.target) && $sleekBarContainer.has(e.target).length === 0) {
            closeSleekBar();
            return false;
        }
    }

    // Listen for ESC button pressed in order to close the sleek bar
    function keyUpEscape(e) {
        if (e.keyCode === 27) {
            closeSleekBar();
        }
    }

    // Listen for scroll event for closing the sleekbar
    window.addEventListener('closeSleekBarEvent', function (event) {
        if($sleekBarContainer.is(':visible')) {
            var win = $(window);
            const $sleekBar = $('.sleek-bar')
            var contHeight = Math.round($sleekBarContainer.outerHeight());

            var sleekBarOffset = $sleekBarContainer.offset().top - win.scrollTop()
            if((contHeight + sleekBarOffset) > win.height() + 20 /* a bit more */) {
                let newMargin = parseInt($sleekBar.css("margin-top")) - event.scrollOffset
                newMargin = newMargin > 0 ? 0 : newMargin;
                $sleekBar.css('margin-top',  newMargin+ "px");
            } else {
                $sleekBar.css('margin-top', "0px");
                closeSleekBar();
            }
        }
      
    }, false);

    $(trigger).click(function (e) {
        e.preventDefault();

        const $clickedLink = $(this);
        toggleLink($clickedLink);
        toggleMenu($clickedLink);

        if(isSleekBarOpened) {
            // bind events are namespaced with the key "outsidesleekbar" to avoid conflicts
            $mainContainer.bind('mousedown.outsidesleekbar', mouseDownOutsideSleekBarListener);
            $document.bind('keyup.outsidesleekbar', keyUpEscape);
        } else {
            $mainContainer.unbind('mousedown.outsidesleekbar', mouseDownOutsideSleekBarListener);
            $document.unbind('keyup.outsidesleekbar', keyUpEscape);
        }

        return false;
    });

    // We stop the propagation of the click event
    // so it will not be catched by the mouseup handler on the body
    $(trigger).mouseup(function (e) {
        e.stopPropagation();
    });
}



// WEBPACK FOOTER //
// ./js/navbar/desktop/NavbarSleekBar.js